module.exports = __webpack_public_path__ + "img/logo_file.a37e2373.svg";